<template>
<div class="main-container privacyPolicy">

		<!-- Navbar section -->
		<Header />
<div class="digital-agency-assistance-area  section-space--ptb_120">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
<p>
    <strong>Whaleio's COVID-19 Response</strong>
</p>
<p>
    Whaleio is committed to providing a safe environment for our employees and
    customers while continuing to deliver mission critical results in a post
    2019 world. Our thoughts are with families and communities that have been
    impacted by this pandemic.
</p>
<p>
    As with many issues in the world, we see this as an opportunity for us to
    have a positive impact on our community. Our entire workforce is
    vaccinated, and we encourage our friends, families, and community to take
    precautions to protect each other during these uncertain times.
</p>
<p>
    Even with all the challenges surrounding COVID-19, we continue to keep our
    focus on the people, meeting our client’s goals and ensuring our employees
    have everything they need to be successful and safe.
</p>
<p>
    While it is hard to know what the future holds, Whaleio will remain
    constant in our commitment to the health and safety of our community.
</p>
  </div></div></div></div>
<!-- footer section -->
        <FooterMain />  
</div>

</template>

<script>
import Header from "@/components/Header";
import FooterMain from "@/components/FooterMain";
export default {
	name: "CovidResponse",
	components: {Header, FooterMain}
}
</script>

<style lang="scss">

</style>